import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { Modal, TextInput } from 'hyperdb-utils';
import CancellationFeeForm from './CancellationFeeForm';

export default class CancellationPolicyTab extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangeCancellationFee = this.handleChangeCancellationFee.bind(this);
    this.handleSaveCancellationFee = this.handleSaveCancellationFee.bind(this);
    this.handleDeleteCancellationFee = this.handleDeleteCancellationFee.bind(this);
    this.state = {};
  }
  render() {
    const cancellationFees = this.getSortedCancellationFees();
    return (
      <div>
        {
          this.props.withName
            ? <TextInput
                label="Name *"
                name="name"
                value={ this.props.objectData.name }
                onChange={ this.handleChange.bind(this, 'name') }
              />
            : null
        }
        <div className="box-header">
          <span>
            <b>Cancellation fees</b>
            &nbsp;
            <button type="button" className="btn btn-xs btn-primary" onClick={ this.handleToggleModalCancellationFee.bind(this, true, -1) }>Add</button>
          </span>
        </div>
        <div className="table-responsive no-padding">
          <table className="table table-hover table-striped table-bordered table-responsive">
            <thead>
              <tr>
                <th>Days until arrival</th>
                <th>Charge (%)</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                cancellationFees.map((cancellationFee, i) => {
                  return (
                    <tr key={ i }>
                      <td>{ cancellationFee.days_until_arrival }</td>
                      <td>{ cancellationFee.value }</td>
                      <td>
                        <DropdownButton title={ <span><i className="fas fa-caret" /> Actions</span> } pullRight bsSize="small" id="Menu actions">
                          <MenuItem onClick={ this.handleToggleModalCancellationFee.bind(this, true, i) }>Edit</MenuItem>
                          <MenuItem onClick={ this.handleToggleModalDeleteCancellationFee.bind(this, i) }>Delete</MenuItem>
                        </DropdownButton>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        {
          this.state.editedCancellationFee
            ? <Modal title="Cancellation fee" onClose={ this.handleToggleModalCancellationFee.bind(this, false) } onAccept={ this.handleSaveCancellationFee }>
                <CancellationFeeForm cancellationFee={ this.state.editedCancellationFee } onChange={ this.handleChangeCancellationFee } />
              </Modal>
            : null
        }
        {
          this.state.cancellationFeeToDelete
            ? <Modal title="Delete cancellation fee" onClose={ this.handleToggleModalDeleteCancellationFee.bind(this, -1) } onAccept={ this.handleDeleteCancellationFee }>
                Are you sure you want to delete this cancellation fee ?
              </Modal>
            : null
        }
      </div>
    );
  }

  getSortedCancellationFees() {
    const cancellationFees = (this.props.objectData.cancellation_fees || []).slice();
    return cancellationFees.sort((a, b) => a.days_until_arrival - b.days_until_arrival);
  }

  handleChange(attributeName, field) {
    const value = field.value;
    if (!this.props.onChange) {
      this.props.api.cancellationPolicy.updateEditedObject({ attributeName, value });
    } else {
      const objectData = { ...this.props.objectData, [attributeName]: value };
      this.props.onChange('cancellation_policy', { value: objectData });
    }
  }

  handleToggleModalCancellationFee(bool, indexEditedCancellationFee = -1) {
    if (!bool) return this.setState({ editedCancellationFee: null });
    const editedCancellationFee = bool && indexEditedCancellationFee !== -1
      ? { ...this.getSortedCancellationFees()[indexEditedCancellationFee] }
      : {};
    this.setState({ indexEditedCancellationFee, editedCancellationFee });
  }
  handleChangeCancellationFee(attributeName, field) {
    const value = parseFloat(field.value || '0');
    const editedCancellationFee = { ...this.state.editedCancellationFee };
    editedCancellationFee[attributeName] = value;
    this.setState({ editedCancellationFee });
  }
  handleSaveCancellationFee() {
    if (this.state.editedCancellationFee.days_until_arrival && this.state.editedCancellationFee.value) {
      const cancellationFees = this.getSortedCancellationFees();
      if (this.state.indexEditedCancellationFee === -1) {
        cancellationFees.push(this.state.editedCancellationFee);
      } else {
        cancellationFees[this.state.indexEditedCancellationFee] = this.state.editedCancellationFee;
      }
      this.handleChange('cancellation_fees', { value: cancellationFees });
      this.setState({ editedCancellationFee: null });
    }
  }
  handleToggleModalDeleteCancellationFee(indexDeleteCancellationFee = -1) {
    const cancellationFeeToDelete = indexDeleteCancellationFee !== -1
      ? { ...this.getSortedCancellationFees()[indexDeleteCancellationFee] }
      : null;
    this.setState({ indexDeleteCancellationFee, cancellationFeeToDelete });
  }
  handleDeleteCancellationFee() {
    let cancellationFees = this.getSortedCancellationFees();
    cancellationFees.splice(this.state.indexDeleteCancellationFee, 1);
    if (cancellationFees.length === 0) cancellationFees = null;
    this.handleChange('cancellation_fees', { value: cancellationFees });
    this.setState({ cancellationFeeToDelete: null });
  }
}



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/PropertyEditor/CancellationPolicyTab.jsx